import { get as _get } from "lodash";
import api from "../../helpers/api";

export const getDataSearchFilters = () => {

  return api().get("/search/filter").then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching data search filters."),
      data: {}
    };
  });
}

export const getDashboardCharts = (variables) => {

  return api().options("/search/dashboard", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching search result data."),
      data: {}
    };
  });
}

export const getSearchData = (variables) => {

  return api().options("/search/data", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      statusCode: (res.status || 200),
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      statusCode: (err.status || 400),
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching search result data."),
      data: {}
    };
  });
}

export const exportSearchData = (variables) => {

  return api().options("/search/export", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while exporting search result data."),
      data: {}
    };
  });
}

export const deleteSearchData = (variables) => {

  return api().delete("/search/delete", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while deleting search data."),
      data: {}
    };
  });
}

export const saveSearch = (variables) => {

  return api().post("/search/save_search", (variables || {})).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while saving search."),
      data: {}
    };
  });
}
